export const TOASTER_PADDING_OFFSET = 36;
